import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';
import type { ProviderInfo } from '../types/foundObject';

export function getProviderInfoQueryKey(): readonly [string, number | 'anonymous'] {
  const userId = apiService.getCurrentUserId();
  return ['provider-info', userId ?? 'anonymous'] as const;
}

/** @deprecated Préférer getProviderInfoQueryKey() — conservé pour invalidateQueries partielles. */
export const PROVIDER_INFO_QUERY_KEY = ['provider-info'] as const;

export function useProviderInfo() {
  return useQuery({
    queryKey: getProviderInfoQueryKey(),
    queryFn: async (): Promise<ProviderInfo> => {
      const res = await apiService.getProviderInfo();
      return res.data;
    },
    staleTime: 60_000,
  });
}
